import React, { useState, useEffect, useRef } from "react";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import Table from "../../../components/common/Table/Table";
import Button from "../../../components/common/Button/Button";
import { getApiInstance } from "../../../utils/api";
import { mapList } from "../../../utils/utils";
import { useZone } from "../../../context/ZoneContext";
import { ZONE_LABEL_MAP } from "../../../constants/zones";
import { getZoneLabel } from "../../../utils/zoneLabels";
import { useTranslation } from 'react-i18next'
import { IoMdAdd } from "react-icons/io";

export default function Comunidades({ user }) {
  const tableRef = useRef(null);
  const canAdd = Number(user.codAcceso) === 1 && Number(user.role) !== 4;
  const [comunidades, setComunidades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paises, setPaises] = useState([]);
  const {t} = useTranslation();
  const { selectedZone } = useZone();

  const communityLabel = t('fields.community');

  const columnasComunidades = [
          {
            key: "id",
            label: communityLabel,
            sortable: true,
            visible: false,
          },
          { key: "codComunidad", label: communityLabel, visible: false },
          {
            key: "comunidad",
            label: communityLabel,
            sortable: true,
            visible: true,
          },
          {
            key: "pais",
            label: t('fields.country'),
            sortable: true,
            visible: true,
          },
          { key: "codPais", label: t('fields.country'), visible: false },
        ]

const filterFields = [
  { key: "comunidad", label: communityLabel, type: "multiselect" },
  { key: "pais", label: t('fields.country'), type: "multiselect" },
  { key: "codZona", label: "Zona", type: "multiselect", labelMap: ZONE_LABEL_MAP },
];

    useEffect(() => {
        fetchPaises();
        fetchComunidades();
    }, []);

    const fetchComunidades = async () => {
        setLoading(true);
        const api = getApiInstance();

        try {
            let comunidadesData = [];

            const response = await api.get(
                `/api/Comunidades/GetComunidades`
            );
            comunidadesData = response.data;

            const mappings = [
                {
                    fieldToMatch: "codPais",
                    fieldToAdd: "pais",
                    referenceList: paises,
                    referenceKey: "id",
                    referenceValue: "value",
                },
            ];

            setComunidades(comunidadesData);

            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las comunidades. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchPaises = async () => {
        setLoading(true);
        const api = getApiInstance();

        try {
            let paisesData = [];

            const response = await api.get(
                `/api/Paises/GetPaises`
            );
            paisesData = response.data;

            setPaises([...mapList(paisesData, "pais", "codPais", "codPais")]);

            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los países. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

  console.log(user)

  return (
    <PageLayout
      title={t('communities.title')}
      subtitle={t('communities.subtitle')}
      actions={[
        ...(canAdd
          ? [
              <Button
                key="add"
                variant="filled"
                startIcon={IoMdAdd({})}
                onClick={() => tableRef.current?.openAddModal()}
                endIcon={undefined}
              >
                {`${t('common.add')} ${communityLabel}`}
              </Button>,
            ]
          : []),
      ]}
    >
      <Table
        ref={tableRef}
        hideAddButton={true}
        columns={columnasComunidades}
        dataTable={comunidades}
        showCheckboxes={false}
        actions={["Eliminar", "Editar"]}
        noResultsMessage={t('communities.noCommunitiesFound')}
        searchTerms={["comunidad", "pais"]}
        formElements={[
          {
            elements: [
              {
                name: "comunidad",
                type: "text",
                label: communityLabel,
                placeholder: t('placeholders.enterName'),
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
              {
                name: "codPais",
                type: "select",
                label: t('fields.country'),
                placeholder: t('placeholders.enterCountry'),
                options: paises,
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
            ],
          },
        ]}
        loading={loading}
        filterFields={filterFields}
        showAdvancedFilters={false}
        elementName={communityLabel}
        keyProp="codComunidad"
        sortProp="comunidad"
        addApiUrl="/api/Comunidades/SetComunidad"
        editApiUrl="/api/Comunidades/EditComunidad"
        deleteApiUrl="/api/Comunidades/DeleteComunidad"
        userCodAcceso={Number(user.codAcceso)}
        userCodPerfil={Number(user.role)}
      />
    </PageLayout>
  );
}
